import { useRef } from 'react';
import { useParams } from 'react-router-dom';

import Container from '@material-ui/core/Container';
import useDownloadTerms from '../../hooks/useDownloadTerms';

const FirstBox = ({ handleClickTerms, isLoadingTermsButton, errorRequestTermsPage }) => {
    const ref = useRef();
    const { hashCode } = useParams();
    const [file, isLoadingFile] = useDownloadTerms(hashCode);

    const onClickTerms = (value, e) => {
        e.preventDefault();
        handleClickTerms(value);
    };

    const downloadTerms = () => {
        if (file) {
            ref.current.href = file;
            ref.current.download = 'Términos de confidencialidad.pdf';
            ref.current.click();
        }
    };

    return (
        <Container className="mt-5 mb-4">
            <div className="row">
                <div className="isv-two-button col-lg-10 col-sm-12">
                    <button
                        className="isv-btn isv-btn-circle background-transparent"
                        onClick={downloadTerms}
                        disabled={isLoadingFile}
                    >
                        Descargar
                    </button>
                    <a className="d-none" href="" ref={ref} />
                    <button
                        className="isv-btn isv-btn-circle background-transparent"
                        onClick={(e) => onClickTerms(false, e)}
                        disabled={isLoadingTermsButton}
                    >
                        Rechazar
                    </button>
                </div>
                <div className="col-lg-2 col-sm-12">
                    <button
                        className="isv-btn isv-btn-circle btn-red btn-size-2 btn-font btn-block ml-2"
                        onClick={(e) => onClickTerms(true, e)}
                        disabled={isLoadingTermsButton}
                    >
                        Aceptar
                    </button>
                </div>
            </div>
            {isLoadingTermsButton &&
                <div className="row text-center m-3">
                    <div className="col-12">
                        <span className="spinner-border text-primary" role="status" aria-hidden="true"></span>
                    </div>
                </div>
            }
            {errorRequestTermsPage &&
                <div className="row text-center m-1">
                    <div className="col-12">
                        <span className="text text-bad">No ha sido posible procesar la petición, por favor intente más tarde</span>
                    </div>
                </div>
            }
        </Container>
    );
};

export default FirstBox;
